//devnet
export const environment = {
  production: true,
  organizationName: 'Pupa', // This will be overwritten by the script during build time
  domain: 'https://www.thepupa.org',
  robots: "noindex, follow",
  twitterId: '@PupaTwit',
  googleAppsScriptUrl: 'https://script.google.com/macros/s/AKfycbwVzyknsXPB3UDaNYaymF40VehNKvI6fsd2FO-rvyq3sdICF_WP6FNRoWzuL54GwUJp/exec',
};
